module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (201).c1e0e29d.jpg";